import { Injectable } from '@angular/core';
import { environment } from '@nrwl/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class UploadFileService {
  public env = environment;
  public uploadFiles: any = [];
  public saveUploadFiles: any = [];

  get uploadMedia(): any {
    return this.uploadFiles;
  }

  set uploadMedia(val: any) {
    if (val) {
      this.uploadFiles.push(val);
    } else if (val === null) {
      this.uploadFiles = [];
    }
  }

  get saveMedia(): any {
    return this.saveUploadFiles;
  }
  set saveMedia(val: any) {
    if (val) {
      this.saveUploadFiles.push(val);
    } else if (val === null) {
      this.saveUploadFiles = [];
    }
  }

  constructor(private http: HttpClient) {}

  public uploadMediaFile(data: FormData) {
    return this.http.post(`${this.env.baseAPIUrl}userfile/`, data);
  }

  public uploadMediaFileV3(id) {
    return this.http.get(`${this.env.baseAPIUrlv3}user-file/${id}/`);
  }
}
